import useValidationModal from '@/@core/components/base-modal/hooks/useValidationModal'
import { privilegeHistoryModel } from '@/models/privilege/privilege-history'
import router from '@/router'
import store from '@/store'
import useFlatPickr from '@/utils/hooks/useFlatPickr'
import useFilterHeaderTable from '@/views/components/filter-header-table/useFilterHeaderTable'
import usePagination from '@/views/components/pagination/usePagination'
import { onBeforeMount, reactive, watch } from '@vue/composition-api'

export default function usePrivilegeHistory() {
  const { resolveDate, resolveTime, resolveFullTime } = useFlatPickr()

  const { pagination, onPageChange, onFilterEntity } = usePagination()

  const {
    filters,
    ordering,
    onSetValueSearch,
    onSelectFilter,
  } = useFilterHeaderTable()

  const {
    openDefaultErrorModal,
    openWarningModal,
    openSuccessModal,
  } = useValidationModal()

  const { fetchPrivilegeHistoryList: fetchListData } = privilegeHistoryModel()

  const privilegeHistoryDetail = reactive({
    privilegeId: 0,
    privilegeType: 0,
    ref: '',
    nameEn: '',
    nameTh: '',
    image:
      '',
  })

  const loading = reactive({
    tableData: false,
  })

  const fields = [
    { key: 'seq', label: 'No.' },
    { key: 'code_ref', label: 'Code Ref' },
    { key: 'mobile_no', label: 'Mobile No.' },
    { key: 'first_name', label: 'First Name' },
    { key: 'last_name', label: 'Last Name' },
    { key: 'qty', label: 'Qty' },
    { key: 'expire_date', label: 'Expire Date' },
    { key: 'updatedtime', label: 'Order Date' },
    { key: 'order_date', label: 'Latest update' },
    { key: 'remark', label: 'Remark' },
    { key: 'actions', label: '' },
  ]

  const privilegeHistoryTable = reactive({
    payload: [],
  })

  const fetchPrivilegeHistoryList = () => {
    loading.tableData = true;
    const payload = {
      Page: pagination.currentPage,
      Limit: pagination.perPage,
      Filters: filters,
      Ordering: ordering.value,
      Privilege_Id: router.currentRoute.params.ref,
    }

    fetchListData.payload = payload

    store
      .dispatch('api/apiRequest', fetchListData)
      .then(resp => {
        const respData = resp.data

        privilegeHistoryDetail.ref = respData.privilege.alt_reference
        privilegeHistoryDetail.nameEn = respData.privilege.name_en
        privilegeHistoryDetail.nameTh = respData.privilege.name_th
        privilegeHistoryDetail.image = respData.privilege.image_url
        privilegeHistoryDetail.privilegeType = respData.privilege.type

        privilegeHistoryTable.payload = respData.payload
        pagination.rows = respData.payload.length
        pagination.totalRows = respData.filtered_record
      })
      .catch(err => {
        openDefaultErrorModal()
      })
      .finally(() => {
        loading.tableData = false
      })
  }

  onBeforeMount(async () => {
    fetchPrivilegeHistoryList()
  })

  watch(
    pagination,
    () => {
      if (!loading.tableData) {
        fetchPrivilegeHistoryList()
      }
    },
    { deep: true },
  )

  watch(
    [filters, ordering],
    () => {
      pagination.currentPage = 1

      fetchPrivilegeHistoryList()
    },
    { deep: true },
  )

  return {
    pagination,
    onPageChange,
    onFilterEntity,
    onSetValueSearch,
    privilegeHistoryDetail,
    loading,
    fields,
    privilegeHistoryTable,
    resolveDate,
    resolveTime,
    resolveFullTime,
  }
}
